import {api2Endpoint} from 'app/config/apiConfig'
import {postData} from 'app/hooks/api/usePostData'
import {queryDefaults} from 'app/react-query'
import {useQuery} from 'react-query'

export function useGetEntitySearchV2<T>(args?: {
  entity: string
  search_str?: string
  select?: string
  page?: number
  items_per_page?: number
  filters?: Record<string, any>
  fuzzyOrder?: string[]
  with_count?: boolean
}) {
  const entity = args?.entity
  const page = args?.page ?? 1
  const per_page = args?.items_per_page ?? 10
  const select: Record<string, any> = {'*': ''}
  if (entity === 'innovation') {
    select['business'] = {'*': ''}
  }
  const filters: Record<string, any> = args?.filters ?? {}
  const fuzzyOrder: string[] = args?.fuzzyOrder ?? []
  const search_str = args?.search_str ?? ''
  const withCount = args?.with_count ?? true
  return useQuery({
    queryKey: [
      `${entity}`,
      filters,
      `${JSON.stringify(filters)}search-p${page}-pp${args?.items_per_page}`,
      fuzzyOrder,
      search_str,
    ],
    queryFn: async () => {
      //fuzzy order only doing one string, so using search string to cover boxes or any other fields so this only does order or filters but not both
      let filtFormat
      if (
        search_str &&
        !Object.keys(filters).includes('name%') &&
        (!fuzzyOrder || fuzzyOrder.length === 0)
      ) {
        if (entity !== 'concept') {
          fuzzyOrder.push('name~' + search_str)
          filtFormat = {
            select: select,
            order: fuzzyOrder,
            per_page: per_page,
            page: page,
            with_count: withCount,
          }
        } else {
          fuzzyOrder.push(`concept_aliases.name~${search_str}`)
          filtFormat = {
            select: select,

            order: fuzzyOrder,
            per_page: per_page,
            page: page,
            with_count: withCount,
          }
        }
      } else {
        //don't send fuzzy
        filtFormat = {
          select: select,
          filter: filters,
          per_page: per_page,
          page: page,
          with_count: withCount,
        }
      }

      const retval = await postData<any>(api2Endpoint(`graph/${entity}`), filtFormat, 'post')
      if (retval)
        return {
          count: retval?.count ?? 0,
          records: retval.records ?? [],
          next: retval?.next,
          prev: retval?.prev,
        }

      return undefined
    },
    cacheTime: 0,
    staleTime: queryDefaults.staleTime,
    retry: queryDefaults.retry,
  })
}
